
import { Button } from "@/components/ui/button";
import { List, MapPin } from "lucide-react";
import PropertySearchFilters from "./PropertySearchFilters";

interface SearchFilters {
  location: string;
  cities: string;
  states: string;
  zipCodes: string;
  minPrice: string;
  maxPrice: string;
  bedrooms: string;
  bathrooms: string;
  propertyType: string;
  minArv: string;
  maxArv: string;
  status: string;
}

interface PropertySearchHeaderProps {
  viewMode: "list" | "map";
  onViewModeChange: (mode: "list" | "map") => void;
  filters: SearchFilters;
  onFiltersChange: (filters: SearchFilters) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
}

const PropertySearchHeader = ({
  viewMode,
  onViewModeChange,
  filters,
  onFiltersChange,
  onApplyFilters,
  onClearFilters
}: PropertySearchHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Search Properties</h1>
        <p className="text-muted-foreground">Find investment opportunities that match your criteria</p>
      </div>
      <div className="flex items-center gap-2">
        <PropertySearchFilters
          filters={filters}
          onFiltersChange={onFiltersChange}
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
        />

        <div className="border rounded-lg p-1" data-tour="view-toggle">
          <Button
            variant={viewMode === "list" ? "default" : "ghost"}
            size="sm"
            onClick={() => onViewModeChange("list")}
          >
            <List className="h-4 w-4" />
          </Button>
          <Button
            variant={viewMode === "map" ? "default" : "ghost"}
            size="sm"
            onClick={() => onViewModeChange("map")}
          >
            <MapPin className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PropertySearchHeader;
